import { createAction } from "@reduxjs/toolkit";

export const resetSearchInfo = createAction("resetSearchInfo");
